var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 19,
    viewBox: "0 0 33 19",
    enableBackground: "new 0 0 33 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "M11.825 2.003h9.19v14.966h-9.19V2.003z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB001B",
    d: "M12.772 9.487c-.002-2.92 1.342-5.679 3.646-7.481-3.914-3.067-9.534-2.62-12.911 1.026s-3.377 9.268 0 12.914c3.377 3.646 8.997 4.092 12.911 1.025-2.305-1.803-3.649-4.563-3.646-7.484z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F79E1B",
    d: "M31.078 16.357v-1.113h.224v-.229h-.534v.229h.211v1.113h.099zm1.035 0v-1.343h-.16l-.189.959-.188-.959h-.162v1.343h.117V15.34l.174.872h.121l.176-.872v1.017h.111zM31.863 9.487c0 3.644-2.088 6.968-5.375 8.56s-7.197 1.174-10.07-1.078c2.303-1.805 3.646-4.562 3.646-7.483 0-2.92-1.344-5.679-3.646-7.483C19.291-.249 23.201-.668 26.488.924s5.375 4.917 5.375 8.561v.002z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.024a8e2acde1d563b5318c45ce749490.svg";
export { ForwardRef as ReactComponent };